import { TooltipWrapper } from "./TooltipWrapper";

export const TechnologyCard = ({ image, title }) => {
  return (
    <TooltipWrapper tooltip={title} position={"left"}>
      <div className="tech-card">
        <img className="tech-icon " src={image} alt={title} />
      </div>
    </TooltipWrapper>
  );
};